export enum MANAGE_API_PATHS {
  SIGNIN = 'admin/auth/sign-in',
  SIGNOUT = 'admin/auth/sign-out',
  PROTO_ACCOUNT_SESSION = 'proto/accounts/session',
  PROTO_ACCOUNTS = 'proto/accounts',
  VEHICLES = 'admin/vehicles',
  VEHICLE_GROUPS = 'admin/vehicle-groups',
  VEHICLE_CATEGORIES = 'admin/vehicle-categories',
  VEHICLE_COLORS = 'admin/vehicle-colors',
  VEHICLE_MAKES = 'admin/vehicle-makes',
  VEHICLE_MODELS = 'admin/vehicle-makes/models',
  LOCATIONS = 'admin/locations',
  CUSTOMERS = 'admin/customers',
  SUPPLIERS = 'admin/suppliers',
  AGENTS = 'admin/agents',
  AGENT_CATEGORIES = 'admin/agent-categories',
  TAGS = 'admin/tags',
  RENTALS = 'admin/rental-agreements',
  MAINTENANCES = 'admin/vehicle-maintenances',
  RESERVATIONS = 'admin/rental-reservations',
  ROAD_TAXES = 'admin/vehicle-road-taxes',
  ROAD_WORTHY_CHECKS = 'admin/vehicle-road-worthy-checks',
  DAMAGES = 'admin/vehicle-damages',
  INSURANCES = 'admin/vehicle-insurances',
  TRANSACTIONS = 'admin/transactions',
  SETTINGS = 'admin/settings',
  USER_SETTINGS = 'admin/user-settings',
  USER_APP_SETTINGS = 'admin/user-app-settings',
  COUNTRIES = 'admin/settings/countries/list',
  LANGUAGES = 'admin/settings/languages/list',
  QUOTATIONS_VEHICLES = 'admin/quotations/vehicles',
  QUOTATIONS_VEHICLE_CATEGORIES = 'admin/quotations/vehicle-categories',
  SUMMARY = 'admin/summary',
  GPS_TRACKING = 'admin/gps-tracking',
  VERSION = 'version',
}
